import { render } from "./FilesResourceModal.vue?vue&type=template&id=72964b07"
import script from "./FilesResourceModal.vue?vue&type=script&lang=js"
export * from "./FilesResourceModal.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\wynajmy\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"FilesResourceModal.vue"]])

export default __exports__